import { AccountManagement } from "../accountManagement";
import { ContextMenu } from "../contextMenu";
import DraggedTab from "./draggedTab";
import HyperlinkMenu from "./hyperlinkMenu";
import useAccountManagementStore from "../../stores/accountManagementStore";

export function AbsolutePositionedWindows() {
    const isLoading = useAccountManagementStore((state) => state.isLoading);

    return (
        <>
            <DraggedTab />
            <HyperlinkMenu />
            <ContextMenu />
            <AccountManagement />

            {/* Input Blocker to prevent user from spamming requests */}
            {isLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "10000",
                        cursor: "wait",
                    }}
                />
            )}
        </>
    );
}

//TODO: Setup RETURN route for loginFromGoogleVerify
//TODO: Add Hyperlink Menu
